export function strip (num, precision = 12) {
  return +parseFloat(num.toPrecision(precision))
}

export function formatNum (num) {
  // 0也要能留下來，所以只擋undefined
  if (num !== undefined) {
    const integer = num.toString().split('.')[0]
    const decimal = num.toString().split('.')[1] ? `.${num.toString().split('.')[1]}` : ''
    return `${integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${decimal}`
  } else {
    return ''
  }
}
